import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';

export enum IntegrationConfigActionTypes {
  GET_ONBOARDING_URL = 'INTEGRATION_CONFIG.GET_ONBOARDING_URL',
  GET_ONBOARDING_URL_SUCCESS = 'INTEGRATION_CONFIG.GET_ONBOARDING_URL_SUCCESS',
  GET_ONBOARDING_URL_FAIL = 'INTEGRATION_CONFIG.GET_ONBOARDING_URL_FAIL',

  UPDATE_ONBOARDING_URL = 'INTEGRATION_CONFIG.UPDATE_ONBOARDING_URL',
  UPDATE_ONBOARDING_URL_SUCCESS = 'INTEGRATION_CONFIG.UPDATE_ONBOARDING_URL_SUCCESS',
  UPDATE_ONBOARDING_URL_FAIL = 'INTEGRATION_CONFIG.UPDATE_ONBOARDING_URL_FAIL',
}

export interface IGetOnboardingUrlAction extends IBaseAction {
  type: typeof IntegrationConfigActionTypes.GET_ONBOARDING_URL;
}

export interface IGetOnboardingUrlSuccessAction extends IBaseAction {
  type: typeof IntegrationConfigActionTypes.GET_ONBOARDING_URL_SUCCESS;
  onboardingUrl: IOnboardingConfig;
}

export interface IGetOnboardingUrlFailAction extends IBaseAction {
  type: typeof IntegrationConfigActionTypes.GET_ONBOARDING_URL_FAIL;
  error: TAppError;
}

export interface IUpdateOnboardingUrlAction extends IBaseAction {
  type: typeof IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL;
}

export interface IUpdateOnboardingUrlActionSuccessAction extends IBaseAction {
  type: typeof IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL_SUCCESS;
  onboardingUrl: IOnboardingConfig;
}

export interface IUpdateOnboardingUrlActionFailAction extends IBaseAction {
  type: typeof IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL_FAIL;
  error: TAppError;
}

export type TIntegrationConfigAction =
  | IGetOnboardingUrlAction
  | IGetOnboardingUrlSuccessAction
  | IGetOnboardingUrlFailAction
  | IUpdateOnboardingUrlAction
  | IUpdateOnboardingUrlActionSuccessAction
  | IUpdateOnboardingUrlActionFailAction;

export interface IIntegrationConfigState extends IBaseState {
  onboardingUrl: IOnboardingConfig;
}

export interface IOnboardingConfig {
  onboardingErrorCallBack: string;
  onboardingSuccessCallBack: string;
}
